import React from 'react';
import Upsell from '@components/shared/design/Upsell';

export interface Props {
  articleItem?: {
    primary: {
      related_products_title: string | null;
    };
    items?: { related_product_code: string | null }[];
  };
  isMobile?: boolean;
}

const ArticleProductCards: React.FC<Props> = ({ articleItem, isMobile }) => {
  if (!articleItem || !articleItem.items || articleItem.items.length === 0) return null;

  const productCodesOrNull = articleItem.items?.map((item: { related_product_code: string | null }) => item.related_product_code);
  const productCodes = productCodesOrNull.filter((code): code is string => code !== null);

  if (!productCodes || !productCodes.length) {
    return null;
  }
  return <Upsell productCodes={productCodes} title={articleItem.primary.related_products_title} isCarousel={isMobile} isVitals={true} />;
};

export default ArticleProductCards;
